import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListAmenities from "../Components/Amenities/listAmenities";
import AddAmenities from "../Components/Amenities/addAmenities";
import ViewAmenities from "../Components/Amenities/viewAmenities";
import AddSubAmenities from "../Components/Amenities/addSubAmenities";
import EditAmenities from "../Components/Amenities/editAmenities";
import EditSubAmenities from "../Components/Amenities/editSubAmenities";

const AmenitiesRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');a
  return (
    <Routes>
      <Route
        path="/amenities"
        element={<ListAmenities></ListAmenities>}
      ></Route>
      <Route
        path="/amenities/add"
        element={canAdd ? <AddAmenities></AddAmenities> : <Navigate to="/amenities" replace />}
      ></Route>
      <Route
        path="/amenities/edit/:id"
        element={<EditAmenities></EditAmenities>}
      ></Route>
      <Route
        path="/amenities/view/:id"
        element={<ViewAmenities></ViewAmenities>}
      ></Route>
      <Route
        path="/amenities/:id/sub/add"
        element={<AddSubAmenities></AddSubAmenities>}
      ></Route>
      <Route
        path="/amenities/:id/sub/edit"
        element={<EditSubAmenities></EditSubAmenities>}
      ></Route>
    </Routes>
  );
};

export default AmenitiesRoutes;
